import { NextPage } from 'next'
import { useRef } from 'react'
import { BookPageDetail } from 'web_core/assets/book'
import { HeadProps } from 'web_core/assets/Head'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { usePVCounter } from 'web_core/hooks'
import { getDefaultStaticPaths } from 'web_core/utils/static_paths'
import { ContentLayout } from '~/components/Layout/Content'
import { useBookPageProps } from '~/hooks/useBookPageProps'
import { BookPageProps, getBookPageStaticProps } from '~/static_props/book'

export const getStaticPaths = getDefaultStaticPaths

export const getStaticProps = getBookPageStaticProps

const Page: NextPage<BookPageProps> = (staticProps) => {
  const {
    isNotFound,
    book,
    pages,
    currentPage,
    profile,
    category,
    tags,
    references,
    macros,
    badges,
    indexable,
  } = useBookPageProps(staticProps)
  const contentRef = useRef<HTMLDivElement>(null)

  const currentPageIndex = pages?.findIndex((p) => p.id === currentPage?.id)

  const head: HeadProps = {
    title:
      currentPage && book
        ? `【${book.title}】${currentPage.title}`
        : '不明な本のページ',
    description:
      book && currentPage && currentPageIndex !== undefined
        ? `「${book.title}」の${currentPageIndex + 1}ページ目です。${
            currentPage.body
          }`
        : '',
    keyword: tags?.map((tag) => tag.name).join(', '),
    index: indexable,
  }

  usePVCounter(book?.ref ?? null)

  return (
    <ContentLayout
      content={book}
      profile={profile}
      contentRef={contentRef}
      isNotFound={isNotFound}
      pages={pages}
      currentPage={currentPage}
      head={head}
    >
      {book &&
      currentPage &&
      profile &&
      category &&
      tags &&
      macros &&
      references &&
      pages &&
      badges ? (
        <BookPageDetail
          currentPage={currentPage}
          book={book}
          profile={profile}
          category={category}
          tags={tags}
          pages={pages}
          macros={macros}
          references={references}
          contentRef={contentRef}
          badges={badges}
        />
      ) : (
        <LoadingSpinner />
      )}
    </ContentLayout>
  )
}

export default Page
